import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ThemeService } from '@core/services/theme.service';

@Component({
  selector: 'tess-navigation',
  imports: [CommonModule, RouterModule],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationComponent {
  readonly #themeService = inject(ThemeService);

  protected readonly currentTheme = this.#themeService.currentTheme;

  protected changeTheme(): void {
    this.#themeService.toggleTheme();
  }
}
